import { Button, Col, Row, Select } from "antd";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { qaDetailsStore } from "../Stores/QADetailsStore";

export const QuestionDelegatePicker = observer(() => {
  const [dropdownVisible, setDropdownVisible] = React.useState(false);
  const [delegatedUserId, setDelegatedUserId] = React.useState<number>(null);
  const { t } = useTranslation(I18N_NS.QA);

  const handleDelegatedChange = (userId: number) => {
    setDelegatedUserId(userId);
  };

  const submitSelectedUser = async () => {
    await qaDetailsStore.changeDelegated(delegatedUserId);
    setDropdownVisible(false);
  };

  React.useEffect(() => {
    if (qaDetailsStore.data.delegatedToUser) {
      setDelegatedUserId(qaDetailsStore.data.delegatedToUser);
    }
  }, [qaDetailsStore.data.delegatedToUser]);

  return (
    <Row justify="space-between" gutter={10}>
      {dropdownVisible
        ? [
            <Col flex="1 1 auto" key="1">
              <Select value={delegatedUserId} onChange={handleDelegatedChange} style={{ width: "100%" }}>
                {qaDetailsStore.data.actions?.delegateTo?.map((item) => (
                  <Select.Option value={item.id} key={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Col>,
            <Col key="2">
              <Button disabled={!delegatedUserId} onClick={submitSelectedUser}>
                {t("Assign directly")}
              </Button>
            </Col>,
          ]
        : [
            <Col flex="1 1 auto" key="1" style={{ display: "flex", alignItems: "center" }}>
              {qaDetailsStore.data.delegatedTo}
            </Col>,
            !!qaDetailsStore.data.actions?.delegate && (
              <Col key="2">
                <Button onClick={() => setDropdownVisible(true)}>{t("Assign directly")}</Button>
              </Col>
            ),
          ]}
    </Row>
  );
});
